// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__c0Q1z","img":"Footer_img__HSx7J","contentF":"Footer_contentF__DDJuX","copy":"Footer_copy__9nCAK","contactIcons":"Footer_contactIcons__s3Aid"};